import { color } from '@bfa/common-ui';
import React from 'react';
import styled, { css } from 'styled-components';
import { compose, space, SpaceProps } from 'styled-system';

type DividerProps = {
  className?: string;
  /** Whether to show small divider, override default medium size. */
  small?: boolean;
} & SpaceProps;

export const Divider: React.FC<DividerProps> = styled.div<DividerProps>`
  border-bottom: 1rem solid ${color('grayLight')};
  ${({ small }) =>
    small &&
    css`
      border-bottom: 0.1rem solid ${color('grayLight')};
    `}
  ${compose(space)}
`;
